import { Effect } from 'effect';

import type { ContactUsArg } from '@vs-shop/engine/request/backendApi/customer/contactUs';
import { createContactRequest } from '@vs-shop/engine/request/backendApi/customer/contactUs';
import { createFormSubmittedPayload } from '../../utils/gtm/create/form-submitted';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export default function contactUs({ email, message }: ContactUsArg) {
  return Effect.gen(function* () {
    yield* createContactRequest({ email, message });
    yield* createFormSubmittedPayload('Contact', email).pipe(Effect.flatMap(sendGtmEvent));
  });
}
